import {
    CheckBoxOutlineBlank,
    IndeterminateCheckBox,
    Square,
} from "@mui/icons-material";
import { Checkbox, ListItemText, styled } from "@mui/material";
import { IListItem } from "../../interface/list-item";
import { IWithClassName } from "../../theme/default.theme";

interface IOwnProps {
    isChecked?: boolean;
    isIndeterminate?: boolean;
    option: IListItem;
    onChange: (items: Array<IListItem>, isChecked: boolean) => void;
}

const DrawNodeOptions = ({
    option,
    isChecked,
    isIndeterminate,
    onChange,
    className,
}: IOwnProps & IWithClassName) => (
    <div className={className} onChange={() => onChange([option], !isChecked)}>
        <Checkbox
            id={option.id}
            checked={isChecked}
            indeterminate={isIndeterminate}
            icon={<CheckBoxOutlineBlank />}
            checkedIcon={<Square />}
            indeterminateIcon={<IndeterminateCheckBox />}
            disableFocusRipple={true}
            disableRipple={true}
            disableTouchRipple={true}
        />
        <ListItemText primary={option?.name} />
    </div>
);

export default styled(DrawNodeOptions)(() => ({
    display: "flex",
}));
